import React from 'react';
import ChannelsTable from '../../components/ChannelsTable';
import { useTranslation } from 'react-i18next';

const Channel = () => {
  const { t } = useTranslation();

  return (
    <div className='dashboard-container management-container-v4'>
      <h1>{t('channel.title')}</h1>
      <ChannelsTable />
    </div>
  );
};

export default Channel;
